// extracted by mini-css-extract-plugin
export var head = "search-tiles-module--head--1d2f5";
export var search_tiles = "search-tiles-module--search_tiles--d10d8";
export var tiles = "search-tiles-module--tiles--47b06";
export var tileswr = "search-tiles-module--tileswr--019a1";